import React, { Component } from 'react'
import cn from 'classnames'
import { Modal, Input, Table, Popconfirm, Form, InputNumber, Button } from 'antd'
import AddPriceForm from './AddItem'
import { sagaModal } from 'redux-saga-modal'
import styles from './style.module.less'
import * as apis from '@/apis'

const tenantMode = process.env.APP_MODE === 'tenant';
const EditableContext = React.createContext()

class EditableCell extends React.Component {
  getInput = () => {
    if (this.props.inputType === 'number') {
      return <InputNumber min={0} />
    }
    return <Input />
  }

  renderCell = ({ getFieldDecorator }) => {
    const {
      editing,
      dataIndex,
      title,
      inputType,
      record,
      index,
      children,
      ...restProps
    } = this.props

    return (
      <td {...restProps}>
        {!editing ? children : (
          <Form.Item style={{ margin: 0 }}>
            {getFieldDecorator(dataIndex, {
              rules: [
                {
                  required: true,
                  message: `请输入 ${title}!`,
                },
              ],
              initialValue: record[dataIndex],
            })(this.getInput())}
          </Form.Item>
        )}
      </td>
    )
  }

  render() {
    return <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
  }
}

@Form.create()
class PriceTable extends Component {
  state = { editingKey: '', data: [], showTips: false, serviceFee: 0 }

  columns = [
    {
      title: '费用明细',
      dataIndex: 'name',
      key: 'name',
      editable: true,
    },
    {
      title: '费用',
      dataIndex: 'price',
      key: 'price',
      editable: true,
      width: 130,
    },
    {
      title: '操作',
      dataIndex: 'control',
      width: 130,
      render: (text, record) => {
        const { editingKey } = this.state
        const editable = this.isEditing(record)
        return editable ? (
          <center>
            <EditableContext.Consumer>
              {form => (
                <a
                  onClick={() => this.save(form, record.key)}
                  style={{ marginRight: 8 }}
                >
                  保存
                </a>
              )}
            </EditableContext.Consumer>
            <a onClick={() => this.cancel(record.key)}>取消</a>
          </center>
        ) : (
          <center>
            {/* <a
              style={{ marginRight: 8 }}
              disabled={editingKey !== ''}
              onClick={() => this.edit(record.key)}>
              编辑
            </a> */}
            <a onClick={() => this.delete(record.key)}>删除</a>
          </center>
        )
      },
    },
  ]

  isEditing = record => record.key === this.state.editingKey

  cancel = () => {
    this.setState({ editingKey: '' })
  }

  save(form, key) {
    form.validateFields((error, row) => {
      if (error) {
        return
      }
      const newData = [...this.state.data]
      const index = newData.findIndex(item => key === item.key)
      if (index > -1) {
        const item = newData[index]
        newData.splice(index, 1, {
          ...item,
          ...row,
        })
        this.setState({ data: newData, editingKey: '' })
      } else {
        newData.push(row)
        this.setState({ data: newData, editingKey: '' })
      }
    })
  }

  edit(key) {
    this.setState({ editingKey: key })
  }

  delete(key) {
    this.setState({
      data: this.state.data.filter(item => item.key !== key)
    })
  }

  handleAddPrice = value => {
    const entity = {
      key: Math.random().toString(36).slice(-8),
      name: value.name,
      price: value.price
    }

    this.setState({
      data: [...this.state.data, entity],
      editingKey: '',
      showTips: true
    })
    setTimeout(() => {
      this.setState({
        showTips: false
      })
    }, 2000);
  }

  getColumns = () => {
    return this.columns.map(col => {
      if (!col.editable) {
        return col
      }
      return {
        ...col,
        onCell: record => ({
          record,
          inputType: col.dataIndex === 'price' ? 'number' : 'text',
          dataIndex: col.dataIndex,
          title: col.title,
          editing: this.isEditing(record),
        }),
      }
    })
  }

  workerServiceFee = (list = []) => {
    // 点击企业调价
    if (this.props?.clickTarget == 'enterprise') {
      if (this.props?.order?.ticket_type != 2) {
        return false;
      }
    }

    let num = 0;
    list.forEach((item) => {
      num = num + (Number(item.price) || 0);
    });
    apis.workerServiceFee({
      workerFee: num,
      type: this.props?.clickTarget == 'enterprise' ? 2 : 1,
      wid: this.props?.order?.getIn(['worker', '_id'])
    }).then(res => {
      this.setState({
        serviceFee: res.serviceFee
        // serviceFee: res.serviceFee ? res.serviceFee.toFixed(2) : 0
      })
    })
  }

  componentDidMount() {
    const { order, field } = this.props
    const data = order.get(field).toJS()
    this.setState({
      data
    })
  }
  componentDidUpdate(prevProps, prevState) {
    // 参数分别为改变之前的数据状态对象
    if (prevState.data != this.state.data) {
      this.workerServiceFee(this.state.data)
    }
  }
  submitHanler = () => {
    this.props.submit({
      [this.props.field]: this.state.data
    })
  }

  render() {
    const { data } = this.state
    const columns = this.getColumns()
    const total = data.reduce((_total, item) => _total + item.price, 0)

    return (
      <EditableContext.Provider value={this.props.form}>
        <AddPriceForm onSubmit={this.handleAddPrice} />
        <div className={styles.total}>
          <span>总计：</span>

          {this.props?.clickTarget == 'enterprise' ?
            <strong className={styles.num}>{(total + (this.state.serviceFee || 0))?.toFixed(2)}</strong> :
            <strong className={styles.num}>{total ? total?.toFixed(2) : 0}</strong>
          }
          <span className={styles.unit}>元</span>
          {!!this.state.serviceFee && <span>（含平台服务费：{this.state.serviceFee ? this.state.serviceFee?.toFixed(2) : 0}元）</span>}
        </div>
        <Table
          components={{
            body: { cell: EditableCell }
          }}
          dataSource={data}
          locale={{ emptyText: '暂无费用明细' }}
          columns={columns}
          rowClassName="editable-row"
          size="middle"
          pagination={false}
        />

        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between', marginTop: 20
        }}>
          <div>
            {this.state.showTips && <span style={{ color: '#FF6600' }}>已添加，请记得保存</span>}
          </div>
          <Popconfirm
            title="请勿频繁操作，确定要改工费单?"
            placement="topRight"
            onConfirm={this.submitHanler}
            okText="确认"
            cancelText="放弃">
            <Button type="primary">保存</Button>
          </Popconfirm>
        </div>
      </EditableContext.Provider>
    )
  }
}

function changePriceDialog({
  modal: {
    name,
  },
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) {
  return (
    <Modal
      title={ownProps.title}
      destroyOnClose
      footer={null}
      width={500}
      // style={{ top: '30vh' }}
      visible={isOpen}
      onCancel={hide}

      mask={false}
      wrapClassName="order-detail-modal-wrap"
      maskStyle={{ position: 'absolute' }}
      getContainer={() => (ownProps?.ele || document.getElementById('order-detail-wrap')) || window}
    >
      <PriceTable {...ownProps} submit={submit} />
    </Modal>
  )
}

export default sagaModal({
  name: 'ORDER_PRICE_DIALOG',
})(changePriceDialog)
